import { DateTime } from 'luxon';

export function dateFormat(dateString, options = {}) {
  const { timezone = 'utc', withoutTime = false, withCreated = false } = options || {};
  const parsedDate = DateTime.fromISO(dateString, { zone: 'utc' });

  if (!parsedDate.isValid) return '';

  const zonedDate = parsedDate.setZone(timezone);

  let formattedDate;
  let formattedString = `'${withCreated ? 'Created: ' : ''}'MMMM d'${getNumberSuffix(
    zonedDate.day,
  )}', yyyy 'at' hh':'mma '${zonedDate.offsetNameShort}'`;
  if (withoutTime) {
    formattedString = `MMMM d'${getNumberSuffix(zonedDate.day)}', yyyy`;
  }
  try {
    formattedDate = zonedDate.toFormat(formattedString);
  } catch (e) {
    formattedDate = '';
  }

  return formattedDate;
}

function getNumberSuffix(num) {
  const th = 'th';
  const rd = 'rd';
  const nd = 'nd';
  const st = 'st';

  if (num === 11 || num === 12 || num === 13) return th;

  const lastDigit = num.toString().slice(-1);

  switch (lastDigit) {
    case '1':
      return st;
    case '2':
      return nd;
    case '3':
      return rd;
    default:
      return th;
  }
}

export function isValidDate(dateString) {
  // UTC date format YYYY-MM-DD or YYYY-MM-DDT*
  const utcDatePattern = /^(\d{4}-\d{2}-\d{2})(?:T|$)/;

  return utcDatePattern.test(dateString);
}
